const upsellProducts2nd = document.querySelectorAll('.upsell-product');
const productsVariantId = document.querySelectorAll('.extra-product-input.extra-product');
const productsQuantity = document.querySelectorAll('.extra-product-qty.extra-product');
const checkoutPriceButton = document.querySelector('.checkout-now-price');
const plusInput = document.querySelector(".field_quantity .js-add-button");
const minusInput = document.querySelector(".field_quantity .js-minus-button");
const currentQty = document.querySelector(".field_quantity .js-input-value");
const wvr03AtcButtons = Array.from(document.querySelectorAll('.product-form__buttons-checkout:not(.sticky-checkout-button) .wvr03-atc'));
const wvr03AtcButton = wvr03AtcButtons[0] || null;

// --- replace your formatPrice with this ---
function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
  if (isNaN(number) || number == null) return '0';
  const parts = (number / 1).toFixed(precision).split('.');
  const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  return parts.length > 1 ? dollars + decimal + parts[1] : dollars;
}

function formatPrice(cents, format = window.shopCurrency || '{{amount}}') {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const placeholder = /\{\{\s*(\w+)\s*\}\}/;
  const m = format.match(placeholder);
  const value = typeof cents === 'number' ? cents : Number(cents);
  const token = m ? m[1] : 'amount';

  let formatted;
  switch (token) {
    case 'amount':
      formatted = formatWithDelimiters(value / 100, 2);
      break;
    case 'amount_no_decimals':
      formatted = formatWithDelimiters(Math.round(value / 100), 0);
      break;
    case 'amount_with_comma_separator':
      formatted = formatWithDelimiters(value / 100, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      formatted = formatWithDelimiters(Math.round(value / 100), 0, '.', ',');
      break;
    case 'amount_with_space_separator':
      formatted = formatWithDelimiters(value / 100, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      formatted = formatWithDelimiters(Math.round(value / 100), 0, ' ', '.');
      break;
    default:
      formatted = formatWithDelimiters(value / 100, 2);
  }
  return format.replace(placeholder, formatted);
}
window.formatPriceHandler = formatPrice;

function formatAtcTotal(cents) {
  const currency = wvr03AtcButton?.dataset.currency || window.Shopify?.currency?.active;

  if (currency && window.Intl?.NumberFormat) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {}
  }

  return formatPrice(cents);
}

function updateWvr03AtcLabel(totalCents) {
  if (!wvr03AtcButtons.length) return;

  let saving = 0;
  try {
    const variants = JSON.parse(document.querySelector('[data-wvr-atc-variants]')?.textContent || '[]');
    const id = document.querySelector('form.js-main-product-form input[name="id"]')?.value;
    const variant = variants.find(v => String(v.id) === String(id));
    if (variant && document.documentElement.dataset.wvrEvergreenCampaign !== 'true') saving += Math.max(0, Number(variant.compare_at_price || 0) - Number(variant.price)) * Number(currentQty?.value || 1);
    document.querySelectorAll('.upsell-product.checked').forEach(item => {
      if (item.hidden || !item.querySelector('.upsell-checkbox')?.checked) return;
      const index = [...upsellProducts2nd].indexOf(item);
      const input = productsVariantId[index];
      if (!input || input.disabled) return;
      const addons = JSON.parse(item.querySelector('.json-data')?.textContent || '[]');
      const addon = addons.find(v => String(v.id) === String(input.value));
      if (addon) saving += Math.max(0, Number(addon.compare_at_price || 0) - Number(addon.price)) * Number(productsQuantity[index]?.value || 1);
    });
  } catch (error) { saving = 0; }
  const label = `Add to cart for ${formatAtcTotal(totalCents)}${saving > 0 ? ` (SAVE ${formatAtcTotal(saving)})` : ''}`;
  wvr03AtcButtons.forEach(button => {
    // Identical-value writes still fire MutationObservers (Gorgias/analytics react
    // to every batch with forced layout reads on a ~5000-node page), so skip them.
    if (button.dataset.wvrSubmitPending === 'true') return;
    const buttonLabel = button.dataset.wvrDeliveryLabel || (button.disabled ? (button.dataset.wvrSoldOutLabel || 'Sold out') : label);
    if (button.textContent !== buttonLabel) button.textContent = buttonLabel;
  });
}

function getUpsellPriceCents(item) {
  // 1) If variant price already stored on checkbox (your controller flow), use it
  const offerAttr = item.querySelector('.upsell-product--checkbox')?.getAttribute('data-offer-product-price');
  if (offerAttr) return Number(offerAttr) || 0;

  // 2) Otherwise read from the JSON you already embed in each upsell card
  //    This JSON maps variant.id -> { origin_price, compare_at_price }
  try {
    const retailMap = JSON.parse(item.querySelector('.json-data-retail')?.textContent || '{}');
    // If a variant is selected in the <select>, use that; else fall back to first key
    const selectedVariantId = item.querySelector('.upsell-variant-selector')?.value;
    if (selectedVariantId && retailMap[selectedVariantId]?.origin_price != null) {
      return Number(retailMap[selectedVariantId].origin_price) || 0;
    }
    const firstKey = Object.keys(retailMap)[0];
    if (firstKey && retailMap[firstKey]?.origin_price != null) {
      return Number(retailMap[firstKey].origin_price) || 0;
    }
  } catch (e) {}

  // 3) Last-ditch: parse visible text (least reliable, but better than NaN)
  const txt = item.querySelector('.upsell-price')?.textContent || '';
  const digits = txt.replace(/[^\d]/g, '');
  return Number(digits) || 0;
}


function syncUpsellInputState(product, index) {
  const checkbox = product.querySelector('.upsell-checkbox');
  const select = product.querySelector('.upsell-variant-selector');
  const hidden = product.hidden || !!product.closest('[hidden]');
  const selected = !!checkbox?.checked && !checkbox.disabled && !hidden;
  if (checkbox && (hidden || checkbox.disabled)) checkbox.checked = false;
  product.classList.toggle('checked', selected);
  const id = productsVariantId[index], quantity = productsQuantity[index];
  if (!id || !quantity) return;
  id.disabled = !selected;
  quantity.disabled = !selected;
  if (selected && select && /^\d+$/.test(select.value)) id.value = select.value;
}

function selectHandler(select, index) {
  const product = upsellProducts2nd[index];
  if (product) syncUpsellInputState(product, index);
}

upsellProducts2nd.forEach((product, index) => {
  const select = product.querySelector('select');
  product.addEventListener('click', () => {

    setTimeout(() => {
      syncUpsellInputState(product, index);
      setNewPriceHandler(currentQty?.value || 1);
    }, 0);
  })

  select && select.addEventListener('change', () => {
    selectHandler(select, index)

    if (product.classList.contains('see-popup')) {
      product.classList.remove('popup-check', 'select-check', 'see-popup', 'custom-checked', 'shake-anim');

      const label = product.querySelector('label');
      if (label) label.click();
    }
  })

  if (select && product.classList.contains('popup-check') && !product.classList.contains('see-popup')) {
    const selectWrapper = product.querySelector('.upsell-variant-selector-wrapper')
    selectWrapper.addEventListener('click', () => {
      if (!product.classList.contains('extra-see-popup')) {
        document.body.classList.add('show-check-popup-pdp');
        product.classList.add('see-popup', 'custom-checked');
        product.classList.add('extra-see-popup');
      }
    })
  }

  if (product.classList.contains('controller-products')) {
    setTimeout(() => {
      const label = product.querySelector('.label-js-elem');
      label.click();
      label.click();
    }, 0);
  }
});

function setProductVaraint(product, selects, jsonData) {
  const priceElem = product.querySelector('.upsell-price');
  const comparePriceElem = product.querySelector('.compare-price');
  const jsonDataRetails = JSON.parse(product.querySelector('.json-data-retail').textContent);

  let variantTitle = '';
  let variantId = null;
  let variantAvailable = true;
  let variantName = '';
  let variantPrice = 0;
  let variantComparePrice = 0;

  selects.forEach((select, index) => {
    Array.from(select).forEach(option => {
      if (option.selected == true) {
        variantTitle = option.value;
      }
    })
    // variantTitle = variantTitle + select.value;
    // if (index + 1 < selects.length) {
    //   variantTitle = variantTitle;
    // }
  });

  // console.log('variantTitle', variantTitle);
  // console.log('selects', selects);

  jsonData.forEach(variant => {
    if (variant.id == variantTitle) {
      variantId = variant.id;
      variantAvailable = variant.available;
      variantName = variant.title;
      variantComparePrice = variant.compare_at_price;
      variantPrice = variant.price;
    }
  });

  // console.log('variantId', variantId);
  // console.log('variantPrice', variantPrice);
  // console.log('variantComparePrice', variantComparePrice);

  if (variantId) {

    const originRetail = product.querySelector('.origin-retail');
    const comparePrice = product.querySelector('.compare-retail');

    if (jsonDataRetails[variantId]) {
      // console.log(jsonDataRetails[variantName]);
      // console.log(variantName);

      originRetail.innerText = formatPrice(jsonDataRetails[variantId].origin_price);

      if (comparePrice) {
        const showCompare = variantComparePrice > variantPrice;
        comparePrice.innerText = showCompare ? formatPrice(variantComparePrice) : '';
        comparePrice.hidden = !showCompare;
      }
    }

    product.setAttribute('data-variant-id', variantId);
    product.setAttribute('data-available', variantAvailable);
    // checkoutPriceButton.dataset.offerProductPrice = variantPrice;
    product.querySelector(".upsell-product--checkbox").dataset.offerProductPrice = variantPrice;
    // console.log('variantPrice', variantPrice);
    priceElem.innerText = formatPrice(variantPrice);

    const savingsBadge = product.querySelector('.wvr-upsell-save');
    if (savingsBadge) {
      const savings = Math.max(0, Number(variantComparePrice || 0) - Number(variantPrice || 0));
      savingsBadge.textContent = savings > 0 ? `${formatPrice(savings)} OFF` : '';
      savingsBadge.hidden = savings <= 0;
    }

    // The interim innerText writes that used to live here were overwritten milliseconds
    // later by setNewPriceHandler's own pass; each one was a separate mutation batch
    // that re-triggered the analytics observers. setNewPriceHandler is the single
    // owner of the checkout-price text.
    setTimeout(() => {
      setNewPriceHandler(currentQty?.value || 1);
    }, 1);



    // console.log('checkoutPriceButton', checkoutPriceButton);
    // let newPrice = 


    if (variantComparePrice > variantPrice) {
      // comparePriceElem.innerText = formatPrice(variantComparePrice);
    }
  }

}

function setProductPadding(product) {
  const selectsWrapper = product.querySelector('.upsell-variant-selector-wrapper');
  const value = selectsWrapper.offsetHeight;

  product.setAttribute('style', `padding-bottom: ${value + 20}px !important;`)
}

const upsellProductsController = document.querySelectorAll('.upsell-product');
document.addEventListener('DOMContentLoaded', () => {

  upsellProductsController.forEach(product => {
    const jsonData = JSON.parse(product.querySelector('.json-data').textContent);
    const selects = product.querySelectorAll('.upsell-variant-selector');

    selects.forEach(select => {
      select.addEventListener('change', () => {
        setProductVaraint(product, selects, jsonData);
      })
    });

    const label = product.querySelector('.upsell-product--checkbox');
    label.addEventListener('click', () => setProductVaraint(product, selects, jsonData));

    setProductPadding(product);
  });
})

const upsellProductsSimple = document.querySelectorAll('.upsell-product');
upsellProductsSimple.forEach(item => {
  if (!item.classList.contains('controller-products')) {
    const label = item.querySelector('.label-js-elem');

    label.addEventListener('click', () => {
      setTimeout(() => {
        setNewPriceHandler(currentQty?.value || 1);
      }, 0);
    });
  }
});

window.addEventListener('resize', () => {
  upsellProductsController.forEach(product => setProductPadding(product));
})

document.body.addEventListener('click', (e) => {
  if (!e.target.classList.contains('upsell-variant-selector') && !e.target.classList.contains('label-js-elem')) {
    const upsellItem = e.target.closest('.upsell-product');

    if (upsellItem) {
      upsellItem.querySelector('.upsell-product--checkbox label').click();
    }
  }
})

window.addEventListener('load', () => {
  const checkoutButton = document.querySelector('.checkout-now-price');
  if (checkoutButton) checkoutButton.dataset.price = window.newPrice || checkoutButton.dataset.price || 0;
  if (checkoutPriceButton) {
    checkoutPriceButton.innerText = ` - ${formatPrice(+(window.newPrice || 0) + +(window.prodPrice || 0))}`;
  }
  setNewPriceHandler(currentQty?.value || 1);
})

// One click fans out to this handler from several listeners (label click, document
// change, product click, nested timeouts). Coalesce them into a single deferred pass:
// every extra DOM-write batch wakes the analytics MutationObservers (Gorgias, PostHog,
// heatmap.com), whose forced layout reads on this page cost hundreds of ms per batch.
let priceUpdateScheduled = false;
function setNewPriceHandler(qty) {
  if (!checkoutPriceButton) return;
  if (priceUpdateScheduled) return;
  priceUpdateScheduled = true;

  setTimeout(() => {
    priceUpdateScheduled = false;
    // Read quantity fresh at flush time so the coalesced pass uses the latest value.
    const liveQty = currentQty?.value || qty || 1;
    const checkedProducts = document.querySelectorAll(".upsell-product.checked");
    const productSubtotal = Number(checkoutPriceButton.getAttribute("data-product-price-one")) * Number(liveQty || 1);

    if (checkedProducts.length > 0) {
      let offerPrice = 0;
      checkedProducts.forEach(element => {
        const index = [...upsellProducts2nd].indexOf(element);
        if (!element.hidden && element.querySelector('.upsell-checkbox')?.checked && !productsVariantId[index]?.disabled) {
          offerPrice += getUpsellPriceCents(element) * Number(productsQuantity[index]?.value || 1);
        }
      });

      const bundleTotal = productSubtotal + offerPrice;
      const checkoutTotal = Number(checkoutPriceButton.dataset.price) + bundleTotal;
      const text = ` - ${formatPrice(checkoutTotal)}`;
      if (checkoutPriceButton.innerText !== text) checkoutPriceButton.innerText = text;
      updateWvr03AtcLabel(bundleTotal);
    } else {
      const checkoutTotal = Number(checkoutPriceButton.getAttribute("data-price")) + productSubtotal;
      const text = ` - ${formatPrice(checkoutTotal)}`;
      if (checkoutPriceButton.innerText !== text) checkoutPriceButton.innerText = text;
      updateWvr03AtcLabel(productSubtotal);
    }
  }, 1);
}

plusInput?.addEventListener("click", () => {
  setTimeout(() => {
    setNewPriceHandler(currentQty.value);
  }, 0);
})

minusInput?.addEventListener("click", () => {
  setTimeout(() => {
    setNewPriceHandler(currentQty.value);
  }, 0);
})

document.addEventListener('change', event => {
  if (event.target.matches('.upsell-checkbox, .upsell-variant-selector, .js-main-product-quantity-input')) {
    upsellProducts2nd.forEach((product, index) => syncUpsellInputState(product, index));
    setNewPriceHandler(currentQty?.value || 1);
  }
});

// This initial UI filter is not a submit-time availability or quantity guarantee.
// The common form submit performs a fresh check and reconciles the actual cart
// after any uncertain add response, including a possible partially applied 422.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.upsell-product').forEach((product, index) => {
    const dataEl = product.querySelector('.json-data');
    const select = product.querySelector('.upsell-variant-selector');
    if (!dataEl) return;

    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const byId = {};
    variants.forEach(v => { byId[String(v.id)] = v; });

    // Fully sold out (card-level class, or no variant left in stock): say it.
    // The stock CSS only strikes the checkbox with a diagonal line, which reads
    // as an unexplained symbol — replace the price with "Sold out" and disable
    // the controls so the state is legible and not actionable.
    const noneAvailable = !variants.some(v => v.available);
    if (product.classList.contains('is-sold-out') || noneAvailable) {
      const priceEl = product.querySelector('.upsell-price');
      if (priceEl && !product.querySelector('.wvr-upsell-soldout-label')) {
        // Status label next to the untouched purchase price. The discount badge and
        // the struck-through compare price are hidden with style.display, because
        // the theme CSS overrides the hidden attribute on these elements.
        const status = document.createElement('span');
        status.className = 'wvr-upsell-soldout-label';
        status.textContent = 'Sold out';
        status.style.cssText = 'color:#9aa0a6;font-weight:600;margin-right:8px;';
        priceEl.parentNode.insertBefore(status, priceEl);
      }
      const compareEl = product.querySelector('.compare-retail');
      if (compareEl) compareEl.style.display = 'none';
      const saveEl = product.querySelector('.wvr-upsell-save');
      if (saveEl) saveEl.style.display = 'none';
      const selWrap = product.querySelector('.upsell-variant-selector-wrapper');
      if (selWrap) selWrap.style.display = 'none';
      const checkbox = product.querySelector('.upsell-checkbox');
      if (checkbox) { checkbox.checked = false; checkbox.disabled = true; }
      syncUpsellInputState(product, index);
      product.classList.add('is-sold-out');
      product.setAttribute('aria-disabled', 'true');
      product.style.opacity = '0.55';
      return;
    }

    if (!select) return;

    Array.from(select.options).forEach(option => {
      const v = byId[String(option.value)];
      if (v && v.available === false) {
        option.disabled = true;
        if (!/sold out/i.test(option.text)) option.text = option.text + ' — Sold out';
      }
    });

    const current = byId[String(select.value)];
    if (current && current.available === false) {
      const firstAvailable = variants.find(v => v.available);
      if (firstAvailable) {
        select.value = String(firstAvailable.id);
        // Propagates to the hidden items[n][id] input and the price display via
        // the existing change listeners; safe at load time (no popup is open).
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
});

setNewPriceHandler(currentQty?.value || 1);
